const courseEditView = {
  MiniCourses: 'Mini Courses',
  Completion: 'Completion',
  LandingPage: 'Landing Page',
}

export default courseEditView
